import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

import { useAppStore } from '../stores/appStore.ts';
import {getMe} from "@/services/actorenApi.ts";

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        component: () => import('../components/MainLayout.vue'),

        children: [
            { path: '',  component: () => import('../pages/Klant_Main.vue'), meta: { requiresAuth: true }},
            { path: 'klant', component: () => import('../pages/Klant_Main.vue'), meta: { requiresAuth: true }},
            { path: 'expert', component: () => import('../pages/Konto_Dashboard.vue'), meta: { requiresAuth: true }},
            { path: 'organisatieadmin', component: ()  => import('../pages/OrganisatieAdmin.vue'), meta: { requiresAuth: true }},
            { path: 'settings', component: () => import('../pages/Konto_Settings.vue'), meta: { requiresAuth: true }},
            { path: 'details/:zaakId', component: () => import('../pages/Konto_ZaakDetails.vue'), meta: { requiresAuth: true }},
            { path: 'afspraken', component: () => import('../pages/Konto_Afspraken.vue'), meta: { requiresAuth: true }},
            { path: 'zaken', component: () => import('../pages/Konto_MijnZaken.vue'),  meta: { requiresAuth: true }},
            { path: 'zaak/edit', component: () => import('../pages/Konto_Editzaak.vue'), meta: { requiresAuth: true }},
            { path: 'archief', component: () => import('../pages/Konto_Archieven.vue'), meta: { requiresAuth: true }},
            { path: 'rekeningen', component: () => import('../pages/Konto_Afrekening.vue'), meta: { requiresAuth: true }},
            { path: 'beheer/actoren', component: () => import('@/pages/Beheer_Actoren.vue'), meta: { roles: ['ADMIN'] }},
            { path: 'beheer/accounts', component: () => import('@/pages/Beheer_Kontos.vue'), meta: { roles: ['ADMIN'] }},
            { path: 'beheer/addenda', component: () => import('@/pages/Beheer_Addenda.vue'), meta: { roles: ['ADMIN'] }
            },
            { path: 'beheer/health', component: () => import('../pages/Beheer_Gezondheid.vue'), meta: {  requiresAuth: true, roles: ['ADMIN'] }},
            { path: 'beheer/zaken', component: () => import('../pages/Beheer_Zaken.vue'), meta: {  requiresAuth: true,  roles: ['ADMIN'] }},
            { path: 'beheer/toepassing', component: () => import('../pages/Beheer_Toepassing.vue'), meta: {  requiresAuth: true, roles: ['ADMIN'] }},
            { path: '/about',
                meta: { requiresAuth: false },
                name: 'Over ons',
                component: () => import('@/pages/static/OverOns.vue')
            },
            { path: 'privacy',
                meta: { requiresAuth: false },
                component: () => import('@/pages/static/Privacy.vue')
            },
            {
                path: 'gebruiksvoorwaarden',
                meta: { requiresAuth: false },
                component: () => import('@/pages/static/Gebruiksvoorwaarden.vue')
            }

        ]
    },
    {
        path: '/forbidden',
        meta: { requiresAuth: false },
        name: 'Forbidden',
        component: () => import('../pages/Forbidden.vue')
    },
    {
        path: '/registreren',
        meta: { requiresAuth: false },
        name: 'Registreer',
        component: () => import('../pages/Registreer.vue')
    },
    {
        path: '/registreer-bevestig',
        meta: { requiresAuth: false },
        name: 'RegistreerBevestig',
        component: () => import('../pages/RegistreerBevestig.vue')
    },
    {
        path: '/reset-wachtwoord',
        meta: { requiresAuth: false },
        name: 'WachtwoordVernieuwen',
        component: () => import('../pages/WachtwoordVernieuwen.vue')
    },
    {
        path: '/wachtwoord-vergeten',
        meta: { requiresAuth: false },
        name: 'WachtwoordVergeten',
        component: () => import('../pages/WachtwoordVergeten.vue')
    },
    {
        path: '/login',
        meta: { requiresAuth: false },
        name: 'Login',
        component: () => import('../pages/Login.vue')
    },
    {
        path: '/gast-toegang',
        meta: { requiresAuth: false },
        name: 'MaakGastToegang',
        component: () => import('../pages/MaakGastToegang.vue')
    },
    {
        path: '/wizard',
        meta: { requiresAuth: true },
        name: 'Wizard',
        component: () => import('../pages/Wizard.vue')
    },
    {
        path: '/kontonietgeldig',
        meta: { requiresAuth: true },
        name: 'Kontonietgeldig',
        component: () => import('../pages/Konto_NietGeldig.vue')
    },
    {
        path: '/uwgegevens',
        meta: { requiresAuth: true },
        name: 'Uw gegevens',
        component: () => import('../pages/MyProfile.vue')
    },
    {
        path: '/oauth2/redirect',
        meta: { requiresAuth: false },
        name: 'OAuth2Redirect',
        component: () => import('../pages/OAuth2Redirect.vue')
    },
    {
        path: '/settings/agendacallback',
        meta: { requiresAuth: true },
        name: 'agendacallback',
        component: () => import('../pages/AgendaCallback.vue')
    }
]

export const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
})

router.beforeEach(async (to) => {

    console.log('guard fired', to.path, to.meta)
    if (to.meta.requiresAuth == false) return true;

    const appStore = useAppStore();

    // Check if we have a valid session
    const hasSession = await appStore.checkBackendSession()
    if (!hasSession) {
        console.log('>>>>>NO SESSION, redirecting to login fullPath ' + to.fullPath)
        return {
            name: 'Login',
            query: { redirect: to.fullPath }
        }
    }

    // Ensure user profile is loaded in appStore

    if (!appStore.userProfile || !appStore.userProfile.rol) {
        try {
            const profile = await getMe()
            await appStore.initializeUserProfile(profile)
        } catch (error) {
            console.error('Failed to load user profile:', error)
            return { name: 'Login' }
        }
    }
    if (appStore.userProfile?.rol == 'KONTO') {
        if (appStore.userProfile?.konto?.id && appStore.konto.kontoSettings == null) {
            await appStore.initializeUserData()
        }
    }

    // Check for role-based access control
    if (to.meta && to.meta.roles) {
        const requiredRoles = to.meta.roles as string[]
        const userRole = appStore.userProfile.rol
        
        if (!requiredRoles.includes(userRole)) {
            console.warn(`User role ${userRole} is not authorized for ${to.fullPath}`)
            return { name: 'Forbidden' }
        }
    }

    return true
})
